import { css } from 'styled-components';
import BulkActions from 'granite-admin/core/components/Table/BulkActions';
// import Sidebar from 'granite-admin/core/components/Sidebar';

const baseSpacing = 20;
const theme = {
  anchor: {
    color: 'secondary',
    fontWeight: 400
  },
  button: {
    primary: {
      extend: ({
        colorValue
      }) => {
        switch (colorValue) {
          case 'text':
            return {
              color: '#222D39',
              border: '1px solid #222D39',
              borderRadius: '6px',
              background: 'white',
              padding: '4px 1.5rem'
            };
          case 'white':
            return {
              color: '#fbab31',
              borderRadius: '4px',
              borderColor: '#fbab31'
            };
          case 'secondary':
            return {
              borderRadius: '18px'
            };
          default:
            return {
              color: 'white',
              borderRadius: '4px'
            };
        }
      }
    },
    extend: {
      fontWeight: 500,
      fontSize: 12,
      margin: {
        bottom: '2.25rem'
      }
    },
    padding: {
      vertical: '6px',
      horizontal: '2rem'
    }
  },
  formField: {
    label: {
      size: '12px',
      margin: {
        horizontal: 'none',
        vertical: 'small'
      },
      color: 'dark-1',
      weight: 400
    },
    error: {
      margin: 'none',
      weight: 400,
      size: '12px',
      color: {
        dark: 'white',
        light: 'status-error'
      }
    },
    extend: ({
      noBorder,
      displayName
    }) => css`
        ${noBorder && `> label + div {
          border: none;
          > div {
            padding: 0;
          }
        }
        > div {
          border: none;
          > div {
            padding: 0;
          }
        }`}
        ${displayName === 'CheckBox' && `
        > div  {
          height: 39.1px;
          justify-content: flex-end;
        }
        `}
      `
  },
  icon: {
    size: {
      small: '14px',
      medium: '28px',
      large: '56px',
      xlarge: '112px'
    }
  },
  global: {
    searchBarBorderRadius: '100px',
    anchor: {
      color: {
        light: 'brand'
      },
      fontWeight: 400
    },
    animation: {
      duration: '0.2s'
    },
    borderSize: {
      xsmall: '0.5px',
      small: '2px',
      medium: '4px',
      large: '6px',
      xlarge: '12px'
    },
    drop: {
      shadowSize: 'large'
    },
    edgeSize: {
      none: '0px',
      hair: '1px',
      xxsmall: '0.125rem',
      xsmall: '0.25rem',
      small: '0.5rem',
      medium: '1rem',
      large: '2rem',
      largePercentage: '2.5%',
      xlarge: '4rem',
      xlargePercentage: '4%',
      xxlarge: '8rem',
      xxlargePercentage: '8%'
    },
    size: {
      xxsmall: '32px',
      xsmall: '64px',
      small: '128px',
      'medium-s': '192px',
      medium: '256px',
      'medium-l': '384px',
      large: '512px',
      xlarge: '768px',
      full: '100%'
    },
    breakpoints: {
      small: {
        value: 768,
        edgeSize: {
          xxsmall: '2px',
          xsmall: '3px',
          small: '6px',
          medium: '12px',
          large: '24px',
          largePercentage: '1.5%',
          xlarge: '48px',
          xlargePercentage: '2%',
          xxlarge: '70px',
          xxlargePercentage: '4%'
        },
        size: {
          xxsmall: '8px',
          xsmall: '12px',
          small: '16px',
          medium: '32px',
          large: '64px',
          xlarge: '128px'
        }
      }
    },
    hover: {
      background: {
        color: 'hover'
      }
    },
    colors: {
      'accent-1': '#162D6E',
      brand: '#FBAB31',
      'brand-dark': '#7D5518',
      'brand-light': '#FDD598',
      border: '#e4e7f0',
      'comp-1': '#2D6E16',
      'comp-2': '#6E162D',
      'dark-1': '#222D39',
      'dark-2': '#707070',
      'dark-3': '#646464',
      hover: 'rgba(253,213,152,0.6)',
      warningBG: '#ff324d33',
      icon: {
        light: '#646464',
        dark: 'white'
      },
      placeholder: '#AAAAAA',
      widgetBackground: '#ffffff',
      labelColor: '#868686',
      bgColor: '#ffffff',
      secondary: '#0E84AD',
      'secondary-light': '#95D7EE',
      'secondary-dark': '#15586F',
      'status-error': '#CC0000',
      'status-ok': '#24A000',
      'status-disabled': '#606060',
      'status-warning': '#D5CE00',
      info: '#08007E',
      darkText: '#222D39',
      text: {
        dark: 'white',
        light: '#222D39'
      },
      textColor: '#222D39',
      'sidebar-background': '#ffffff',
      'sidebar-drops': 'white',
      'sidebar-group': '#606060',
      'sidebar-icon': '#FBAB31',
      'sidebar-hover': '#012a46',
      'sidebar-divider': '#FDD598',
      'sidebar-svg-active': '#FBAB31',
      'sidebar-svg-hover': '#FBAB31',
      'sidebar-svg': '#FBAB31',
      'sidebar-label-active': '#222D39',
      'sidebar-label': '#222D39',
      'sidebar-label-hover': '#222D39',
      'sidebar-label-active-background': 'rgba(253,213,152,0.6)',
      'action-buttons-background': '#FBAB31',
      'full-screen-background-color': 'light-2',
      'notification-avatar-background': '#FFEDE7',
      'notification-avatar-color': '#FBAB31'
    },
    focus: {
      border: {
        color: 'brand'
      }
    },
    font: {
      family: "'Open Sans', sans-serif"
      /* size: '16px',
      height: '20px', */
    },

    input: {
      font: {
        size: 'medium'
      },
      padding: `${baseSpacing / 2}px`,
      weight: 400
    }
  },
  heading: {
    responsiveBreakpoint: 'small',
    extend: {
      marginTop: 0
    },
    font: {
      weight: 600,
      family: "'Muli', sans-serif;"
    },
    level: {
      1: {
        font: {
          weight: 900
        },
        // default size to heading level 1
        small: {
          size: '34px',
          height: '40px'
        },
        medium: {
          size: '50px',
          height: '46px'
        },
        large: {
          size: '82px',
          height: '88px'
        }
      },
      2: {
        small: {
          size: '26px',
          height: '32px'
        },
        medium: {
          size: '34px',
          height: '40px'
        },
        large: {
          size: '50px',
          height: '56px'
        }
      },
      3: {
        small: {
          size: '22px',
          height: '28px'
        },
        medium: {
          size: '26px',
          height: '32px'
        },
        large: {
          size: '34px',
          height: '40px'
        }
      },
      4: {
        small: {
          size: '16px',
          height: '22px'
        },
        medium: {
          size: '18px',
          height: '24px'
        },
        large: {
          size: '20px',
          height: '26px'
        }
      },
      5: {
        font: {
          weight: 400
        },
        small: {
          size: '14px',
          height: '20px'
        },
        medium: {
          size: '16px',
          height: '22px'
        },
        large: {
          size: '18px',
          height: '24px'
        }
      }
    }
  },
  paragraph: {
    // default size to paragraph
    small: {
      size: '14px',
      height: '20px',
      maxWidth: 'none'
    },
    medium: {
      size: '18px',
      height: '24px',
      maxWidth: 'none'
    },
    large: {
      size: '22px',
      height: '28px',
      maxWidth: 'none'
    },
    extend: {
      fontWeight: 300
    }
  },
  radioButton: {
    container: {
      extend: css`
        font-size: 12px;
      `
    },
    size: '14px'
  },
  text: {
    alert: {
      size: '10px',
      maxWidth: 'none'
    },
    xsmall: {
      size: '8px',
      height: '11px',
      maxWidth: 'none'
    },
    small: {
      size: '10px',
      height: '13px',
      maxWidth: 'none'
    },
    medium: {
      size: '12px',
      height: '16px',
      maxWidth: 'none'
    },
    large: {
      size: '14px',
      height: '18px',
      maxWidth: 'none'
    },
    xlarge: {
      size: '16px',
      height: '20px'
    },
    heroDesc: {
      size: '1.875rem',
      height: 'normal',
      maxWidth: 'none'
    }
  },
  textInput: {
    extend: {
      background: 'white',
      fontSize: '12px',
      height: '38px'
    },
    disabled: {
      opacity: 0.5
    }
  },
  maskedInput: {
    extend: {
      background: 'white',
      fontSize: '12px'
    }
  },
  calendar: {
    extend: {
      color: '#000'
    },
    small: {
      daySize: '18px'
    },
    medium: {
      daySize: '36px'
    },
    large: {
      daySize: '72px'
    }
  },
  checkBox: {
    gap: 'medium',
    check: {
      radius: '2px'
    },
    border: {
      color: {
        dark: 'rgba(255, 255, 255, 0.5)',
        light: 'text'
      },
      width: '1px'
    },
    size: '16px',
    toggle: {
      knob: {
        extend: {
          top: '1px',
          left: '2px',
          width: '11px',
          height: '11px'
        }
      },
      size: '35px',
      color: {
        light: '#606060'
      },
      extend: ({
        checked
      }) => {
        if (checked) return {
          borderColor: '#fbab31'
        };
      }
    }
  },
  tab: {
    margin: undefined,
    color: 'text',
    border: {
      color: 'transparent',
      active: {
        color: 'secondary'
      }
    },
    active: {
      color: 'secondary'
    },
    pad: {
      top: 'small',
      horizontal: 'xlarge'
    },
    extend: {
      'padding-bottom': '0.5rem',
      'border-right': '1px solid rgba(198,198,198,0.2)'
    }
  },
  tabs: {
    background: 'white',
    header: {
      extend: {
        justifyContent: 'flex-start'
      }
    }
  },
  table: {
    extend: {
      th: {
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingRight: '2.5rem',
        paddingLeft: '1rem'
      },
      td: {
        wordBreak: 'break-word'
      }
    },
    bulkActionsComponent: BulkActions
  },
  accordion: {
    heading: {
      level: '5',
      margin: {
        vertical: 'small'
      }
    }
  },
  graniteTable: {
    table: {},
    defaultProps: {
      actionsConfig: {
        visibleHover: row => row?.original?.pk ? true : false
      },
      utilsConfig: {},
      selectionConfig: {}
    },
    withDataProps: {},
    filtersDropButtonProps: {
      className: 'filters-drop-button',
      dropProps: {
        align: {
          top: 'bottom',
          left: 'right'
        }
      },
      iconColor: 'white',
      iconSize: '18px',
      iconProps: {},
      dropContentProps: {},
      DropContentComponent: null
    },
    header: {
      background: 'secondary',
      color: 'white',
      fontSize: 'text.medium',
      fontWeight: 'bold'
      /* 
      sort icons colors use Asc and Desc properties if you want to have different colors for them,
      if you wanna change icons or behavior, try passing your own SortIcons component above in graniteTable.defaultProps
      sortAscActiveColor: '',
      sortAscInactiveColor: '',
      sortDescActiveColor: '',
      sortDescInactiveColor: '',
      sortColor: '',
      sortAscColor: '',
      sortDescColor: '',
      sortActiveColor: '',
      sortInactiveColor: '',
       */
    },

    row: {
      background: 'white',
      color: 'text',
      font: 'text.medium',
      hoverBackground: 'hover',
      fontSize: 'text.medium',
      evenRowBackground: '#fbfbfb'
    },
    th: {
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingRight: '2.5rem',
      paddingLeft: '1rem'
    },
    extend: css``,
    clearDashboardFilter: 'brand'
  },
  DNA_SLIDER_WIDTH: '480px',
  // Documents/notes/audits slider width
  // sidebarSettings: {
  //   align: 'left',
  //   width: '256px',
  //   showUserDropMenu: true,
  //   showUserProfile: false,
  //   showReferGranite: true,
  //   SideBarComponent: Sidebar,
  //   layout: '', // leave empty to obey user pref otherwise use => "top_menu_bar/side_menu_bar"
  //   leftGroupVisibleItem: 8, // max num of item to show in left group for top navbar
  //   // getItemCount > a func by which project can decide item count to show as per screen size
  // },
  toast: {
    position: 'top-right',
    margin: {
      top: '20px',
      horizontal: 'xxlarge'
    },
    colors: {
      success: 'status-ok',
      warning: 'status-warning',
      error: 'status-error',
      info: 'info'
    }
  },
  tip: {
    content: {
      background: 'dark-3',
      elevation: 'small',
      margin: 'xsmall',
      pad: {
        vertical: 'xsmall',
        horizontal: 'small'
      },
      round: 'xsmall',
      style: {
        fontSize: '12px'
      }
    },
    drop: {
      align: {
        top: 'bottom'
      },
      background: 'none',
      elevation: 'none',
      margin: 'none'
    }
  },
  gmap: {
    defaultProps: {
      mapConfigs: {},
      markerConfig: {}
    }
  },
  hideTitleOnFormField: false,
  notification: {
    headingColor: 'white',
    moreVerticalColor: 'white'
  }
  // listOpenNewTab: true,
  // showCreateOrganisation: true,
};

export default theme;